import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAll as getProgramResponseData } from 'actions/program-analytics';
import { store } from 'redux-rest-reducer';
import { Checkbox, Label } from 'semantic-ui-react';
import Plot from 'react-plotly.js';
import { aggregateProgram, extractDataForChapter } from './utils/program-compare';
import ProgramAggregationTable from './ptable-analytics';
import { SCORE_COLOR, TIME_COLOR } from 'constants/plot-constants';

function reshapeChapterData(aggregateByChapterDict, chapterVersionDisplay) {
  //console.log('aggregateByChapterDict reshapeChapterData', aggregateByChapterDict);
  let chapterDataList = []; // For Table in Child Component
  let medianScoreList = []; // For Graph
  let medianTimeList = [];
  let q1TimeList = [];
  let q3TimeList = [];
  let q1ScoreList = [];
  let q3ScoreList = [];
  let xAxisLabelList = [];
  let isMaxVersionList = [];
  let maxScoreList = [];

  Object.entries(aggregateByChapterDict).forEach(([chpCode, chpData]) => {
    let chpDisplayVersion;
    if (!chapterVersionDisplay) {
      chpDisplayVersion = Math.max(
        ...Object.keys(chpData).map(ver => parseInt(ver)),
      ).toString();
      isMaxVersionList.push(true);
      //console.log('Type chpDisplayVersion', typeof chpDisplayVersion, chpDisplayVersion, Object.keys(chpData).map((ver)=> parseInt(ver)));
      //console.log('chpData', typeof chpData, Object.keys(chpData).map((ver)=> Number(ver)));
    } else {
      chpDisplayVersion = chapterVersionDisplay[chpCode];
      isMaxVersionList.push(false);
    }
    Object.entries(chpData).forEach(([chpVersion, chpVerData]) => {
      let toggle = false;
      const {
        chapterLink,
        medianScoreChp,
        maxScoreChp,
        q3TimeChp,
        q1ScoreChp,
        q1TimeChp,
        q3ScoreChp,
        medianTimeChp,
      } = extractDataForChapter(chpVerData);
      console.log('extractDataForChapter(chpVerData)', extractDataForChapter(chpVerData));
      //console.log(typeof chpCode, typeof chpData);
      if (chpDisplayVersion && chpVersion === chpDisplayVersion) {
        // TO FILL DATA FOR GRAPH
        xAxisLabelList.push(
          ''.concat(
            "<a href='/chapter-analytics/",
            chpCode,
            '/',
            chpVersion,
            "'>",
            ''.concat(chpCode, '_', chpVersion),
            '</a>',
          ),
        );
        maxScoreList.push(maxScoreChp);
        medianScoreList.push(medianScoreChp);
        medianTimeList.push(medianTimeChp);
        q1TimeList.push(q1TimeChp);
        q3TimeList.push(q3TimeChp);
        q1ScoreList.push(q1ScoreChp);
        q3ScoreList.push(q3ScoreChp);
        toggle = true;
      }
      console.log(
        'All Data',
        xAxisLabelList,
        maxScoreList,
        medianScoreList,
        medianTimeList,
      );
      // TO FILL DATA FOR TABLE

      chapterDataList.push({
        isNew: toggle,
        chapterLink: chapterLink,
        chapterCode: chpCode,
        chapterVersion: chpVersion,
        medianScore: medianScoreChp,
        medianTime: medianTimeChp,
        q1Time: q1TimeChp,
        q3Time: q3TimeChp,
        q1Score: q1ScoreChp,
        q3Score: q3ScoreChp,
        maxScore: maxScoreChp,
      });
    });
  });
  return {
    chapterDataList,
    xAxisLabelList,
    medianScoreList,
    medianTimeList,
    q1TimeList,
    q3TimeList,
    q1ScoreList,
    q3ScoreList,
    isMaxVersionList,
    maxScoreList,
  };
}

export class ProgramAnalytics extends PureComponent {
  constructor() {
    super();
    this.state = {
      aggregateByChapterDict: {},
      chapterDataList: {},
      programData: null,
      xAxisDataLabel: null,
      toggleTimeData: false,
      chapterVersionDisplay: {},
    };
  }

  static getDerivedStateFromProps({ programAnalytics, programCode }) {
    if (programAnalytics) {
      let newState = {};
      const programData = store.getAll(programAnalytics, { programCode });
      if (programData && programData.data) {
        newState['programData'] = programData.data;
        //console.log('programData', programData);
        const { chapterDict } = aggregateProgram(programData.data);
        newState['aggregateByChapterDict'] = chapterDict;
        //console.log('aggregateByChapterDict', chapterDict);
        const {
          chapterDataList,
          xAxisLabelList,
          medianScoreList,
          medianTimeList,
          q1TimeList,
          q3TimeList,
          q1ScoreList,
          q3ScoreList,
          isMaxVersionList,
          maxScoreList,
        } = reshapeChapterData(chapterDict);
        newState['chapterDataList'] = chapterDataList;
        newState['xAxisLabelList'] = xAxisLabelList;
        newState['medianScoreList'] = medianScoreList;
        newState['medianTimeList'] = medianTimeList;
        newState['q1TimeList'] = q1TimeList;
        newState['q3TimeList'] = q3TimeList;
        newState['q1ScoreList'] = q1ScoreList;
        newState['q3ScoreList'] = q3ScoreList;
        newState['isMaxVersionList'] = isMaxVersionList;
        newState['maxScoreList'] = maxScoreList;
      }

      if (newState !== {}) {
        return newState;
      }
    }
    return null;
  }

  componentDidMount() {
    const { programCode } = this.props;
    const { getProgramResponseData } = this.props.actions;
    getProgramResponseData({ programCode });
  }

  toggleTimeCheckbox = () =>
    this.setState(prevState => ({ toggleTimeData: !prevState.toggleTimeData }));

  getData = () => {
    const {
      toggleTimeData,
      xAxisLabelList,
      medianScoreList,
      maxScoreList,
      medianTimeList,
      q3TimeList,
      q1ScoreList,
      q1TimeList,
      q3ScoreList,
    } = this.state;
    console.log(
      'Plot Data',
      xAxisLabelList,
      medianScoreList.map((mdSC, i) => mdSC / maxScoreList[i]),
    );
    let data = [
      {
        x: xAxisLabelList,
        y: toggleTimeData
          ? medianTimeList.map(mTime => mTime / 3600.0)
          : medianScoreList.map((mdSC, i) => mdSC / maxScoreList[i]),
        type: 'bar',
        name: toggleTimeData ? 'TimeData' : 'ScoreData',
        mode: 'lines+percent',
        tickfont: { color: 'rgba(0,0,0,0.5)' },
        marker: { color: toggleTimeData ? TIME_COLOR : SCORE_COLOR }, //ScoreData or timeData
        hoverinfo: 'false',
      },
      {
        x: xAxisLabelList,
        y: toggleTimeData
          ? q3TimeList.map(mTime => mTime / 3600.0)
          : q1ScoreList.map((q1mdSC, i) => q1mdSC / maxScoreList[i]),
        mode: 'line+markers',
        name: 'Bottom 25% Quartile',
        fill: toggleTimeData ? 'tonexty' : 'tozeroy',
        type: 'scatter',
        tickfont: { color: 'rgba(0,0,0,0.65)' },
        visible: 'legendonly',
      },
      {
        x: xAxisLabelList,
        y: toggleTimeData
          ? q1TimeList.map(mTime => mTime / 3600.0)
          : q3ScoreList.map((q3mdSC, i) => q3mdSC / maxScoreList[i]),
        mode: 'line+markers',
        name: 'Top 25% Quartile',
        fill: toggleTimeData ? 'tozeroy' : 'tonexty',
        type: 'scatter',
        tickfont: { color: 'rgba(0,0,0,0.89)' },
        visible: 'legendonly',
      },
    ];
    return data;
  };

  render() {
    const { programCode } = this.props;
    const { toggleTimeData, programData, chapterDataList } = this.state;
    return (
      <Fragment>
        <tr />
        <Label>
          Score <Checkbox toggle onChange={this.toggleTimeCheckbox} /> Time{' '}
        </Label>
        {programData && (
          <Plot
            data={this.getData()}
            layout={{
              width: 1000,
              height: 500,
              hoverlabel: { bgcolor: '#FFF' },
              title: ''.concat(
                programCode,
                ' ',
                toggleTimeData ? 'Time(Hr) Plot' : 'Program plot',
              ),
              yaxis: {
                title: toggleTimeData ? 'Time(Hr)' : 'Accuracy',
                range: toggleTimeData ? [1, 100] : [0, 1],
                autorange: toggleTimeData,
                tickformat: toggleTimeData ? '.0' : ',.0%',
                hoverinfo: 'false',
              },
            }}
          />
        )}
        <ProgramAggregationTable data={chapterDataList} />
      </Fragment>
    );
  }
}

export default connect(
  ({ programAnalytics }, { match: { params: { programCode } } = {} }) => ({
    programAnalytics: programAnalytics,
    programCode: programCode,
  }),
  dispatch => ({
    actions: bindActionCreators({ getProgramResponseData }, dispatch),
  }),
)(ProgramAnalytics);
